module.exports = __webpack_public_path__ + "img/3.b83fab5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3.jpg
// module id = 207
// module chunks = 1